import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setShowStreetView = (
  state: MapState,
  action: PayloadAction<MapState['showStreetView']>
) => {
  state.showStreetView = action.payload;
}